export const Colors = [
  '#C486A7',
  '#D29389',
  '#F3A87F',
  '#FCD492',
  '#FFEB7F',
  '#C0BB8B',
  '#AAC597',
  '#84B89B',
  '#7FAFB1',
  '#80ABCD',
  '#8C91BE',
  '#A69996',
  '#FAC7D8',
  '#F6D1CD',
  '#FFE6C0',
  '#FDEDC0',
  '#FFFFC6',
  '#F3F7CE',
  '#E2F0D2',
  '#C3E7D6',
  '#D9F5F9',
  '#D0E1FD',
  '#CFD4ED',
  '#E7C9EC',
  '#DED5D2',
  '#DEDEDE',
  '#BABABA',
  '#A0A0A0',
  '#7F7F7F'
]

/**
 * Room colors
 * Used as a hover color for different types of apartments
 *
 * [nightColor, lightColor]
 */
export const ROOM_COLORS = [
  ['#B33D3D', '#E64E4E'], // Utility
  ['#B36C3D', '#E68A4E'], // Bedroom
  ['#B39B3D', '#E6C74E'], // Hallway
  ['#9BB33D', '#C8E64E'], // Hall
  ['#6CB33D', '#8BE64E'], // Living
  ['#3DB33D', '#4FE64E'], // Bathroom
  ['#3DB36B', '#4EE68A'], // Rise
  ['#3DB39A', '#4EE6C6'], // Kitchen_living_diner
  ['#3D9CB3', '#4EC9E6'], // Kitchen
  ['#3D6DB3', '#4E8CE6'], // Storage
  ['#3D3EB3', '#4E50E6'], // En-suite
  ['#6A3DB3', '#894EE6'], // Loggy
  ['#1D2733', '#F5F7FB'], // Corridor
  ['#B33D9D', '#E64EC9'], // Unused
  ['#B33D6E', '#E64E8D'] // Unused
]

/**
 * Random colors
 *
 * [nightColor, lightColor]
 */
export const RANDOM_COLORS = [
  ['#42ADAD', '#A6A6FF'],
  ['#9242AD', '#FFA6A6'],
  ['#42AD42', '#A6FFFF'],
  ['#AD4242', '#D3FFA6'],
  ['#AD5D42', '#FFA6BC'],
  ['#AD7842', '#FFA6D3'],
  ['#AD9242', '#FFA6E9'],
  ['#ADAD42', '#FFA6FF'],
  ['#92AD42', '#E9A6FF'],
  ['#78AD42', '#D3A6FF'],
  ['#5DAD42', '#BCA6FF'],
  ['#42AD5D', '#A6BCFF'],
  ['#42AD78', '#A6D3FF'],
  ['#42AD92', '#A6E9FF'],
  ['#4292AD', '#A6FFE9'],
  ['#4278AD', '#A6FFD3'],
  ['#425DAD', '#A6FFBC'],
  ['#4242AD', '#A6FFA6'],
  ['#5D42AD', '#BCFFA6'],
  ['#7842AD', '#E9FFA6'],
  ['#AD42AD', '#FFFFA6'],
  ['#AD4292', '#FFE9A6'],
  ['#AD4278', '#FFE9A6'],
  ['#AD425D', '#FFBCA6']
]

export const STRUCTURE_PICKER_COLORS = [
  '#16a085',
  '#27ae60',
  '#2980b9',
  '#8e44ad',
  '#2c3e50',
  '#f1c40f',
  '#e67e22',
  '#c0392b',
  '#bdc3c7',
  '#7f8c8d'
]

export const GENERAL_COLORS = {
  orange: '#FF8E6A',
  white: '#ffffff',
  black: '#000000',
  lightGray: '#F5F7FB',
  gray: '#79A5D6',
  echoBlue: '#9CAFC7',
  turquoiseDay: '#32A6FE',
  turquoiseNight: '#2974AD',
  turquoiseFontDay: '#4E6A8A',
  turquoiseFontNight: '#5C7EA3',
  blue: '#002E99',
  blurryBlue: '#2974AD',
  darkBlue: '#222E3C',
  navyBlue: '#1D2733',
  red: '#E15556',
  green: '#29AD67',
  smoke: '#CDD8E5',
  nightSmoke: '#314357',
  mgCornDay: '#5CADD6',
  mgCornNight: '#264059',
  deepBlueDay: '#5CCCD6',
  deepBlueNight: '#265559',
  paleDay: '#E8F2FF',
  paleNight: '#293849',
  greenDay: '#8297a6',
  greenNight: '#293E4D',
  warehouseNight: '#2A4D3F',
  warehouseDay: '#61B392',
  parkingNight: '#2A324D',
  parkingDay: '#6174B3',
  yellow: '#E0E155'
}

// 0 index => dark
// 1 index => light
export const { LIGHT_COLORS, DARK_COLORS } = Object.entries({
  background: [GENERAL_COLORS.navyBlue, GENERAL_COLORS.lightGray],
  backgroundRush: [GENERAL_COLORS.darkBlue, GENERAL_COLORS.white],
  action: [GENERAL_COLORS.blurryBlue, GENERAL_COLORS.white],
  mainFont: [GENERAL_COLORS.white, GENERAL_COLORS.darkBlue],
  fontHover: [GENERAL_COLORS.white, GENERAL_COLORS.turquoiseDay],
  gradient: [GENERAL_COLORS.darkBlue, GENERAL_COLORS.gray],
  backgroundHeader: [GENERAL_COLORS.darkBlue, GENERAL_COLORS.blurryBlue],
  additionalFont: [GENERAL_COLORS.gray, GENERAL_COLORS.navyBlue],
  icon: [GENERAL_COLORS.gray, GENERAL_COLORS.lightGray],
  additionalIcon: [GENERAL_COLORS.gray, GENERAL_COLORS.smoke],
  disabled: [GENERAL_COLORS.nightSmoke, GENERAL_COLORS.smoke],
  residential: [GENERAL_COLORS.deepBlueNight, GENERAL_COLORS.deepBlueDay],
  residentialByModular: [
    GENERAL_COLORS.deepBlueNight,
    GENERAL_COLORS.deepBlueDay
  ],
  office: [GENERAL_COLORS.mgCornNight, GENERAL_COLORS.mgCornDay],
  warehouse: [GENERAL_COLORS.warehouseNight, GENERAL_COLORS.warehouseDay],
  parking: [GENERAL_COLORS.parkingNight, GENERAL_COLORS.parkingDay],
  mixedUse: [GENERAL_COLORS.greenNight, GENERAL_COLORS.greenDay],
  modular: [GENERAL_COLORS.greenNight, GENERAL_COLORS.greenDay],
  templateHover: [GENERAL_COLORS.blurryBlue, GENERAL_COLORS.lightGray],
  highLight: [GENERAL_COLORS.blurryBlue, GENERAL_COLORS.turquoiseDay],
  turquoise: [GENERAL_COLORS.turquoiseNight, GENERAL_COLORS.turquoiseDay],
  turquoiseFont: [
    GENERAL_COLORS.turquoiseFontNight,
    GENERAL_COLORS.turquoiseFontDay
  ],
  turquoiseInversed: [
    GENERAL_COLORS.turquoiseFontDay,
    GENERAL_COLORS.turquoiseFontNight
  ],
  pale: [GENERAL_COLORS.paleNight, GENERAL_COLORS.paleDay],
  yellow: [GENERAL_COLORS.yellow, GENERAL_COLORS.yellow]
}).reduce(
  ({ LIGHT_COLORS, DARK_COLORS }, [key, [dark, light]]) => ({
    DARK_COLORS: {
      ...DARK_COLORS,
      [key]: dark
    },
    LIGHT_COLORS: {
      ...LIGHT_COLORS,
      [key]: light
    }
  }),
  {
    LIGHT_COLORS: GENERAL_COLORS,
    DARK_COLORS: GENERAL_COLORS
  }
)

export const DARK_TONES = {
  black: {
    background: '#191A1C',
    backgroundRush: '#232527',
    pale: '#2D2F33',
    disabled: '#373A3E',
    turquoiseFont: '#808080',
    gray: '#6A6E77',
    turquoise: '#2974AD',
    orange: '#A6ADBB',
    office: '#2A384D',
    residential: '#1C3033',
    mixedUse: '#1C2933',
    warehouse: '#1C332A'
  },
  grey: {
    background: '#333333',
    backgroundRush: '#3C3C3C',
    pale: '#494949',
    disabled: '#575757',
    turquoiseFont: '#8A8A8A',
    gray: '#D6D6D6'
  },
  'royal blue': {
    background: '#091C33',
    backgroundRush: '#0A213C',
    pale: '#0C2949',
    disabled: '#324357',
    turquoiseFont: '#4F6B8A',
    gray: '#7AA5D6'
  },
  cyan: {
    background: '#133033',
    backgroundRush: '#16383C',
    pale: '#1B4449',
    disabled: '#205157',
    turquoiseFont: '#33808A',
    gray: '#4FC6D6'
  },
  'dark purple': {
    background: '#241D33',
    backgroundRush: '#2C233D',
    pale: '#332947',
    disabled: '#3A2F52',
    turquoiseFont: '#5F4C85',
    gray: '#A786EB'
  },
  'dark magenta': {
    background: '#331D2C',
    backgroundRush: '#3D2334',
    pale: '#47293D',
    disabled: '#522F46',
    turquoiseFont: '#995783',
    gray: '#EB86C9',
    turquoise: '#AD2981'
  },
  'dark green': {
    background: '#1D332F',
    backgroundRush: '#233D39',
    pale: '#294742',
    disabled: '#2F524C',
    turquoiseFont: '#57998E',
    gray: '#86EBDA',
    turquoise: '#30C7AE'
  },
  'grey green': {
    background: '#21331D',
    backgroundRush: '#273D23',
    pale: '#2E4729',
    disabled: '#34522F',
    turquoiseFont: '#629957',
    gray: '#97EB86',
    turquoise: '#49C730'
  }
}
export const LIGHT_TONES = {
  green: {
    background: '#BDDBC0',
    backgroundRush: '#C8E6C9',
    pale: '#B2CFB7',
    disabled: '#9DB8A5',
    turquoiseFont: '#5F736C',
    gray: '#748A7F',
    turquoise: '#7CB342',
    mainFont: '#1C2223'
  },
  lemon: {
    background: '#EFF2C4', // 190
    backgroundRush: '#FCFFCF', // 200
    pale: '#E2E6BA', // 180 Use pale for map
    disabled: '#C9CCA5', // 160
    turquoiseFont: '#7D8067', // 100
    gray: '#97997C', // 120
    turquoise: '#FF9100',
    mainFont: '#26261F' // 30
  },
  lola: {
    background: '#E6E6E6',
    backgroundRush: '#F2F2F2',
    pale: '#E6E6E6',
    disabled: '#CCCCCC',
    turquoiseFont: '#808080',
    gray: '#999999',
    turquoise: '#666666',
    mainFont: '#262626'
  },
  /*  red: {
    background: '#F2C2C2',
    backgroundRush: '#FFCCCC',
    pale: '#E6B8B8',
    disabled: '#CCA3A3',
    turquoiseFont: '#806666',
    gray: '#997A7A',
    turquoise: '#FF6E40',
    mainFont: '#261F1F'
  }*/
}

export const PALETTE_STRUCTURE_COLORS = {
  Red: '#e05555',
  Orange: '#e0a955',
  Yellow: '#c5e055',
  Green: '#72e055',
  Turquoise: '#55e08c',
  Cyan: '#55e0df',
  'Royal Blue': '#558ee0',
  Blue: '#6f55e0',
  Magenta: '#c355e0',
  Pink: '#e055ab'
}

export const PALETTE_COSTS_COLORS = {
  yellow: '#ADAD42',
  red: '#AD4242',
  blue: '#4242AD'
}

export const LOADS_COLORS = {
  Sea: GENERAL_COLORS.turquoiseDay,
  Country: GENERAL_COLORS.turquoiseDay,
  Town: '#32FEAC'
}

export const CARD_BRAND_COLORS = {
  visa: '#0e4595',
  mastercard: '#000000',
  'american-express': '#2557d6',
  discover: '#ff6000',
  'diners-club': '#0079be',
  jcb: '#0e4c96',
  unionpay: '#022e64',
  elo: '#000000',
  hipercard: '#b3131b',
  maestro: '#000000'
}

export const MAP_BUILDING_COLORS = {
  parking: '#414BB2',
  office: '#2D9BF0',
  residential: '#12CDD4'
}

export const MODEL_BACKGROUND_COLORS = {
  night: ['#805F5F', '#80805F', '#5F805F', '#5F8080', '#5F5F80', '#805F80'],
  day: ['#BF8F8F', '#BFBF8F', '#8FBF8F', '#8FBFBF', '#8F8FBF', '#BF8FBF']
}

export const MAP_COLORS = [
  '#E1CF33',
  '#E02C2C',
  '#41E1E0',
  '#E0652F',
  '#3FE1B0',
  '#C24DE1',
  '#E15556',
  '#8CE137',
  '#6749E1',
  '#3BE14B',
  '#4584E1',
  '#43B2E1',
  '#3DE17E',
  '#E151A8',
  '#4757E1',
  '#5BE139',
  '#954BE1',
  '#BEE135',
  '#E14FD3',
  '#E09A31',
  '#E1537F',
  '#E0482E'
]

/**
 * Apartment colors by type
 *
 * type: [nightColor, lightColor]
 */
const APARTMENTS_COLORS = {
  studio: ['#B33D3D', '#E64E4E'],
  one: ['#3DB33D', '#4FE64E'],
  two: ['#3D6DB3', '#4E8CE6'],
  three: ['#B33D6E', '#E64E8D']
}

export const APARTMENTS_TYPES_COLORS = {
  StudioBedApartment: APARTMENTS_COLORS.studio,
  StudioFlats: APARTMENTS_COLORS.studio,
  Studio: APARTMENTS_COLORS.studio,
  OneBedApartment: APARTMENTS_COLORS.one,
  OneBedroomFlats: APARTMENTS_COLORS.one,
  '1 Bed': APARTMENTS_COLORS.one,
  TwoBedApartment: APARTMENTS_COLORS.two,
  TwoBedroomFlats: APARTMENTS_COLORS.two,
  '2 Bed': APARTMENTS_COLORS.two,
  ThreeBedApartment: APARTMENTS_COLORS.three,
  ThreeBedroomFlats: APARTMENTS_COLORS.three,
  default: [GENERAL_COLORS.nightSmoke, GENERAL_COLORS.smoke],
  corridor: [GENERAL_COLORS.gray, GENERAL_COLORS.gray],
  '3 Bed': APARTMENTS_COLORS.three
}
